import { useMutation } from '@tanstack/react-query'
import { createNewRoster, NewRosterRequest } from 'api/worker'
import { useAuthContext } from 'components/auth'

interface UseCreateRosterMutation {
  onSuccess?: () => void
}

export function useCreateRosterMutation(options?: UseCreateRosterMutation) {
  const { company } = useAuthContext()

  return useMutation({
    mutationFn: async (data: NewRosterRequest) => {
      if (!company?.id) {
        throw new Error('Company id not found')
      }
      return createNewRoster(company.id, data)
    },
    ...options,
  })
}
